import MapLayout from './HOClevel';

export default MapLayout;
